import { render, staticRenderFns } from "./TableByWell.vue?vue&type=template&id=a6bb1ac6&scoped=true"
import script from "./TableByWell.vue?vue&type=script&lang=js"
export * from "./TableByWell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.44_cache-loader@4.1.0_webpack@4.47.0_supports-_3d59c31a03e2fcdc80db74fb8fd2eaf6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bb1ac6",
  null
  
)

export default component.exports